import React from 'react'
import { TextField, useTranslate, FunctionField } from 'react-admin'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '1em',
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  th: {
    width: '130px',
    fontWeight: 'bold',
  },
  title: {
    marginBottom: '0.5em',
  },
  green: {
    color: '#90C53C',
  },
  orange: {
    color: 'orange',
  },
  red: {
    color: 'red',
  },
}))

const STATUS = {
  shipped: 9,
  delivered: 10,
  returned: 12,
}

export const ChargeBeeDetailsCard = ({ basePath, record, resource }) => {
  const classes = useStyles()
  const translate = useTranslate()
  const sanitizedProps = { basePath, record, resource }

  return (
    <Paper className={classes.paper} variant="outlined" square>
      <Typography className={classes.title} variant="h6">
        {translate('resources.order.cards.chargeBee')}
      </Typography>
      <Table aria-label="simple table">
        <TableBody>
          <TableRow key="Table-Row-chargeBee-id">
            <TableCell className={classes.th} component="th" scope="row">
              {translate('resources.order.chargeBee')}
            </TableCell>
            <TableCell align="left">
              <TextField
                {...sanitizedProps}
                source="chargeBeeData.invoice_id"
              />
            </TableCell>
          </TableRow>
          <TableRow key="Table-Row-chargeBee-status">
            <TableCell className={classes.th} component="th" scope="row">
              {translate('resources.order.chargeBeeStatus')}
            </TableCell>
            <TableCell align="left">
              <FunctionField
                addLabel={false}
                {...sanitizedProps}
                source="chargeBeeStatus.slug"
                render={(record) => {
                  if (record.chargeBeeStatus.id === STATUS.delivered) {
                    return (
                      <div className={classes.green}>
                        {record.chargeBeeStatus.slug}
                      </div>
                    )
                  } else if (
                    [STATUS.shipped].includes(record.chargeBeeStatus.id)
                  ) {
                    return (
                      <div className={classes.orange}>
                        {record.chargeBeeStatus.slug}
                      </div>
                    )
                  } else if (record.chargeBeeStatus.id === STATUS.returned) {
                    return (
                      <div className={classes.red}>
                        {record.chargeBeeStatus.slug}
                      </div>
                    )
                  } else {
                    return <div>{record.chargeBeeStatus.slug}</div>
                  }
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  )
}
